import { PracticeInfo } from "../redux/slice/practice/practiceRegistrationSlice";
import { EDIT_PRACTICE_URL, SAVE_PRACTICE_PHARMACY_CONFIG_URL, FETCH_PRACTICE_URL, SUBMIT_PRACTICE_URL,FETCH_PRACTICE_LOCATIONS_URL, FETCH_PRACTICE_PROVIDERS_URL, FETCH_PRACTICE_PRODUCTS_URL, FETCH_ALL_PRODUCTS_URL, SAVE_PRACTICE_LOCATION_URL, SAVE_PRACTICE_PROVIDER_URL, INACTIVE_PRACTICE_LOCATION_URL, INACTIVE_PRACTICE_PROVIDER_URL, FETCH_PRACTICE_BILLER_URL, FETCH_PRACTICE_EXECUTIVE_URL, UPDATE_PRACTICE_BILLER_URL, UPDATE_PRACTICE_EXECUTIVE_URL, GET_PRACTICE_LOCATION_BY_LOCATIONID_URL, FETCH_PRACTICE_PRODUCTS_WITHOUT_DETAILS_URL, FETCH_PRACTICE_BY_USER_ROLE, FETCH_UPDATED_PRACTICE_REGISTRATION_BY_PRACTICE_ID_URL, DOWNLOAD_UPDATED_REGISTRATION, FETCH_PRACTICE_PROVIDERS_LIST_URL, FETCH_PRACTICE_PROVIDER_BY_USER_ID_URL, FETCH_ALL_USED_PROVIDER_IDS_URL, FETCH_ALL_PROVIDER_USED_PRACTICE_IDS_URL, GET_IS_LAST_PROVIDER_BY_USER_ID_URL, FETCH_PRACTICES_BY_IDS_URL, SEARCH_PROVIDER_URL, FETCH_PRACTICE_BY_USER_ROLE_IVR_ORDER, ADD_PRACTICE_AUTHORIZED_SIGNER, INACTIVE_AUTHORIZED_SIGNER_URL, FETCH_PRACTICE_PRODUCTS_BY_MFR_URL, FETCH_ALL_PROVIDERS, FETCH_ACTIVE_PRACTICE_LOCATIONS_FOR_GIVEN_DATE, FETCH_PRACTICE_LIST_FOR_FILTER, GET_PROVIDER_TEMPLATES_BY_PROVIDERID_URL, FETCH_PRACTICE_TEMPLATES_URL, FETCH_PRACTICE_USERS_URL, ADD_AUTHORIZED_PROVIDER_USERS_URL, FETCH_ALL_AUTHORIZED_PROVIDER_USERS_URL, DELETE_AUTHORIZED_PROVIDER_USERS_URL, EDIT_AUTHORIZED_PROVIDER_USERS_URL, GET_AUDIT_LOGS_FOR_PRACTICE_DOS_PREFERENCE_URL, CREATE_PRACTICE_AND_ACCOUNT_URL, VALIDATE_PRACTICE_DETAILS_URL, VERIFY_NPI, COMPLETE_PRACTICE_REGISTRATION } from "./URL";
import { http } from "./http";
import { PracticeLocationInfo } from "../redux/slice/practice/practiceLocationSlice";
import { PracticeProviderInfo, SearchProviderRequest } from "../redux/slice/practice/practiceProvidersSlice";
import { PracticeEditInfo } from "../redux/slice/practice/practiceEditSlice";
import { UpdatePracticeExInfo } from "../redux/slice/practice/practiceExecutiveSlice";
import { InterceptorOption } from "../types/CommonTypes";

export const submitPractice = async (submitPracticeRequest: PracticeInfo | null, interceptorOption: InterceptorOption) => {
    try{
        const response = await http.post(SUBMIT_PRACTICE_URL, submitPracticeRequest, undefined, interceptorOption);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const editPractice = async (editPracticeRequest: PracticeEditInfo) => {
    const response = await http.post(EDIT_PRACTICE_URL, editPracticeRequest);
    return response;
};

// CS-2075 — pharmacy billing codes have their own endpoint; add / update / delete
// all post here (delete sends an empty billingCode).
export const savePracticePharmacyConfig = async (request: {
    practiceId: number;
    pharmacyKey: string;
    billingCode: string;
}) => {
    const response = await http.post(SAVE_PRACTICE_PHARMACY_CONFIG_URL, request);
    return response;
};

export const fetchPracticeById = async (practiceId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_URL}?practiceId=${practiceId}`);
    return response;
};

export const fetchPracticesByIds = async (practiceIds: number[]) => {
    const response = await http.get(`${FETCH_PRACTICES_BY_IDS_URL}?practiceIds=${practiceIds}`);
    return response;
};

export const fetchPracticeLocationsById = async (practiceId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_LOCATIONS_URL}?practiceId=${practiceId}`);
    return response;
};

export const fetchActivePracticeLocationsById = async (practiceId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_LOCATIONS_URL}?practiceId=${practiceId}&onlyActiveRecords=${true}`);
    return response;
};

export const fetchPracticeProvidersById = async (practiceId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_PROVIDERS_URL}?practiceId=${practiceId}`);
    return response;
};

export const fetchPracticeProviderByUserId = async (userId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_PROVIDER_BY_USER_ID_URL}?userId=${userId}`);
    return response;
};

export const fetchIsLastProviderByUserId = async (userId: string) => {
    const response = await http.get(`${GET_IS_LAST_PROVIDER_BY_USER_ID_URL}?userId=${userId}`);
    return response;
};

export const fetchAllUsedProviderIds = async () => {
    const response = await http.get(`${FETCH_ALL_USED_PROVIDER_IDS_URL}`);
    return response;
};

export const fetchAllProviderUsedPracticeIds = async () => {
    const response = await http.get(`${FETCH_ALL_PROVIDER_USED_PRACTICE_IDS_URL}`);
    return response;
};

export const fetchActivePracticeProvidersById = async (practiceId: string, onlyActiveRecords: boolean) =>{
    const response = await http.get(`${FETCH_PRACTICE_PROVIDERS_URL}?practiceId=${practiceId}&onlyActiveRecords=${onlyActiveRecords}`);
    return response;
};

export const fetchActivePracticeProvidersByIds = async (practiceIds: number[], onlyActiveRecords: boolean, headers: Record<string, string>) =>{
    const response = await http.get(`${FETCH_PRACTICE_PROVIDERS_LIST_URL}?practiceIds=${practiceIds}&onlyActiveRecords=${onlyActiveRecords}`, { headers: {...headers} });
    return response;
};

export const fetchPracticeProductsById = async (practiceId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_PRODUCTS_URL}?practiceId=${practiceId}`);
    return response;
};
// CS-1240
export const fetchPracticeProductsByIdWithModule = async (practiceId: number ,moduleName?:string) => {
    const response = await http.get(`${FETCH_PRACTICE_PRODUCTS_URL}?practiceId=${practiceId}&moduleName=${moduleName}`);
    return response;
};
//
export const fetchPracticeProductsByIdUsingDateOfServiceAndProvider = async (
    practiceId: number,
    dateOfService?: string,
    providerId?: number,
    moduleName?: string,
    includeRxRequiredProducts?: boolean,
    skipLoader: boolean = false
) => {
    const response = await http.get(
        `${FETCH_PRACTICE_PRODUCTS_URL}?practiceId=${practiceId}&dateOfService=${dateOfService}&providerId=${providerId}&moduleName=${moduleName}&includeRxRequiredProducts=${includeRxRequiredProducts ?? false}`,
        { headers: { "x-skip-loader": skipLoader.toString() } }
    );
    return response;
};
export const fetchPracticeProductsListByMfr= async (data:any) => {
    const response = await http.post(FETCH_PRACTICE_PRODUCTS_BY_MFR_URL,data);
    return response;
};

export const fetchAllProducts = async () => {
    const response = await http.get(`${FETCH_ALL_PRODUCTS_URL}`);
    return response;
};

export const savePracticeLocation = async (practiceLocation: PracticeLocationInfo) => {
    try{
        const response = await http.post(SAVE_PRACTICE_LOCATION_URL, practiceLocation);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const savePracticeProvider = async (practiceProvider: PracticeProviderInfo) => {
    try{
        const response = await http.post(SAVE_PRACTICE_PROVIDER_URL, practiceProvider);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const inactivePracticeLocations = async (locationId: number, inactiveDate: any) => {
    try{
        // CS-1984: drop the stray `&` after `?` (was `?&inactiveDate=` → empty leading pair). Equivalent request, valid URL.
        // const response = await http.post(`${INACTIVE_PRACTICE_LOCATION_URL}/${locationId}?&inactiveDate=${inactiveDate}`);
        const response = await http.post(`${INACTIVE_PRACTICE_LOCATION_URL}/${locationId}?inactiveDate=${inactiveDate}`);  // CS-1984
        return response;
    }
    catch(error){
        throw error;
    }
};

export const inactivePracticeProviders = async (providerId: number, inactiveDate: any) => {
    try{
        // CS-1984: drop the stray `&` after `?` (was `?&inactiveDate=` → empty leading pair). Equivalent request, valid URL.
        // const response = await http.post(`${INACTIVE_PRACTICE_PROVIDER_URL}/${providerId}?&inactiveDate=${inactiveDate}`);
        const response = await http.post(`${INACTIVE_PRACTICE_PROVIDER_URL}/${providerId}?inactiveDate=${inactiveDate}`);  // CS-1984
        return response;
    }
    catch(error){
        throw error;
    }
};

export const inactiveAuthorizedSigners = async (data:any,interceptorOption: InterceptorOption) => {
    try{
        const response = await http.post(`${INACTIVE_AUTHORIZED_SIGNER_URL}`,data,undefined,interceptorOption);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const fetchPracticeBillerById = async (practiceId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_BILLER_URL}?practiceId=${practiceId}`);
    return response;
};

export const fetchPracticeExecutiveById = async (practiceId: number, isInactive?: boolean) => {
    const response = await http.get(`${FETCH_PRACTICE_EXECUTIVE_URL}?practiceId=${practiceId}&isInactive=${isInactive}`);
    return response;
};

{/* CS-1348 - Start */ }
export const updatePracticeBiller = async (practiceBillerId: string, billerId: string, practiceId: String) => {
    try {
        const response = await http.post(`${UPDATE_PRACTICE_BILLER_URL}?practiceBillerId=${practiceBillerId}&billerId=${billerId}&practiceId=${practiceId}`);
        return response;
    } catch (error) {
        throw error;
    }
};
{/* CS-1348 - End */ }

export const updatePracticeExecutive = async (data : UpdatePracticeExInfo) => {
    try {
        const response = await http.post(`${UPDATE_PRACTICE_EXECUTIVE_URL}`, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getLocationsByLocationId = async (locationId: number) => {
    try{
        const response = await http.get(`${GET_PRACTICE_LOCATION_BY_LOCATIONID_URL}?locationId=${locationId}`);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const fetchPracticeProductsWithoutDetailsById = async (practiceId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_PRODUCTS_WITHOUT_DETAILS_URL}?practiceId=${practiceId}`);
    return response;
};

export const fetchPracticesByUserRole = async (isActivePracticeOnly?: boolean, skipLoader: boolean = false) => {
    try {
        const response = await http.get(`${FETCH_PRACTICE_BY_USER_ROLE}?isActivePracticeOnly=${isActivePracticeOnly}`, {
            headers: { "x-skip-loader": skipLoader.toString() },
        });
        return response;
    } catch (error) {
        throw error;
    }
}
// CS-1300
export const fetchPracticeListForFilter = async (skipLoader: boolean = false) => {
    try {
        const response = skipLoader
            ? await http.get(`${FETCH_PRACTICE_LIST_FOR_FILTER}`, { headers: { "x-skip-loader": "true" } })
            : await http.get(`${FETCH_PRACTICE_LIST_FOR_FILTER}`);
        return response;
    } catch (error) {
        throw error;
    }
}
//

export const fetchPracticesByUserRoleIvrorder = async (isActivePracticeOnly?: boolean) => {
    try {
        const response = await http.get(`${FETCH_PRACTICE_BY_USER_ROLE_IVR_ORDER}?isActivePracticeOnly=${isActivePracticeOnly}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const fetchPracticesByUserRoleIvrOrderSkipLoading = async (isActivePracticeOnly: boolean, headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_PRACTICE_BY_USER_ROLE_IVR_ORDER}?isActivePracticeOnly=${isActivePracticeOnly}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchUpdatedPracticeRegistrationByPracticeId = async (practiceId: string, updatePracticeAgreement: boolean) => {
    try {
        const response = await http.get(`${DOWNLOAD_UPDATED_REGISTRATION}/${practiceId}?updatePracticeAgreement=${updatePracticeAgreement}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchAgreementByProductIdAndPracticeId = async (practiceId: string, productId: string) => {
    try {
        const response = await http.get(`${FETCH_UPDATED_PRACTICE_REGISTRATION_BY_PRACTICE_ID_URL}?practiceId=${practiceId}&productId=${productId}`);
        return response;
    } catch (error) {
        throw error;
    };
};

export const providerSearchService = async (providerSearchRequest: SearchProviderRequest) => {
  try {
    const response = await http.post(SEARCH_PROVIDER_URL, providerSearchRequest);
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchsaveAuthorizedSigners = async (data:any, interceptorOption: InterceptorOption) => {
    try {
      const response = await http.post(ADD_PRACTICE_AUTHORIZED_SIGNER, data, undefined, interceptorOption);
      return response;
    } 
    catch (error) {
      throw error;
    }
  };

  export const fetchAllProviders = async () => {
    try {
        const response = await http.get(`${FETCH_ALL_PROVIDERS}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getActiveLocationsForGivenDate = async (practiceId: string, effectiveDate: string) => {
    try {
        // CS-1984: drop the stray `&` after `?` (was `?&practiceId=` → empty leading pair). Equivalent request, valid URL.
        // const response = await http.get(`${FETCH_ACTIVE_PRACTICE_LOCATIONS_FOR_GIVEN_DATE}?&practiceId=${practiceId}&effectiveDate=${effectiveDate}`);
        const response = await http.get(`${FETCH_ACTIVE_PRACTICE_LOCATIONS_FOR_GIVEN_DATE}?practiceId=${practiceId}&effectiveDate=${effectiveDate}`);  // CS-1984
        return response;
    } catch (error) {
        throw error;
    }
}

export const fetchProviderTemplatesByProviderId = async (providerId: string) => {
    const response = await http.get(`${GET_PROVIDER_TEMPLATES_BY_PROVIDERID_URL}?providerId=${providerId}`);
    return response;
};

//CS-1310 - Start (Practice template related service)
export const fetchPracticeTemplates = async (practiceId: string) => {
    const response = await http.get(`${FETCH_PRACTICE_TEMPLATES_URL}/${practiceId}`);
    return response;
};
//CS-1310 - End


//CS-1395 - Phase 2 Start
export const fetchPracticeUserByPracticeId = async (practiceId: number) => {
    const response = await http.get(`${FETCH_PRACTICE_USERS_URL}/${practiceId}`);
    return response;
};
export const fetchAllAuthorizedProviderUser = async (practiceId: number) => {
    const response = await http.get(`${FETCH_ALL_AUTHORIZED_PROVIDER_USERS_URL}?practiceId=${practiceId}`);
    return response;
};
export const addAuthorizedProviderUser = async (userData: any) => {
    const response = await http.post(ADD_AUTHORIZED_PROVIDER_USERS_URL,userData);
    return response;
};

export const deleteAuthorizedProviderUser = async (providerAuthorizedUserId: number) => {
    const response = await http.delete(`${DELETE_AUTHORIZED_PROVIDER_USERS_URL}?providerAuthorizedUserId=${providerAuthorizedUserId}`);
    return response;
};

export const editAuthorizedProviderUser = async (userData: any) => {
    const response = await http.post(EDIT_AUTHORIZED_PROVIDER_USERS_URL, userData);
    return response;
};

//CS-1395 - Phase 2 End

export const getAuditLogsForPracticeDOSPreference = async (practiceId: number) => {
    const response = await http.get(`${GET_AUDIT_LOGS_FOR_PRACTICE_DOS_PREFERENCE_URL}?practiceId=${practiceId}`);
    return response;
};

export const createPracticeAndUserAccount = async (practiceData: any) => {
    const response = await http.post(CREATE_PRACTICE_AND_ACCOUNT_URL, practiceData);
    return response;
};

export const validatePracticeRegistrationDetails = async (practiceData: any) => {
    const response = await http.post(VALIDATE_PRACTICE_DETAILS_URL, practiceData);
    return response;
};

export const verifyNpi = async (npiNumber: string) => {
    const response = await http.get(`${VERIFY_NPI}/${npiNumber}`);
    return response;
};

export const completeRegistration = async (submitPracticeRequest: PracticeInfo | null, interceptorOption: InterceptorOption) => {
    try{
        const response = await http.post(COMPLETE_PRACTICE_REGISTRATION, submitPracticeRequest, undefined, interceptorOption);
        return response;
    }
    catch(error){
        throw error;
    }
};